import {
    ADD_SHIPPING_ZONE_FAIL,
    ADD_SHIPPING_ZONE_SUCCESS,
    DELETE_SHIPPING_ZONE_FAIL,
    DELETE_SHIPPING_ZONE_SUCCESS,
    EXPORT_SHIPPING_ZONE_FAIL,
    EXPORT_SHIPPING_ZONE_SUCCESS,
    GET_SHIPPING_ZONE_DETAILS_FAIL,
    GET_SHIPPING_ZONE_DETAILS_SUCCESS,
    GET_SHIPPING_ZONE_LISTING_FAIL,
    GET_SHIPPING_ZONE_LISTING_SUCCESS,
    RESET_SHIPPING_ZONE_ACTION_STATE,
    RESET_SHIPPING_ZONE_STATE,
    UPDATE_SHIPPING_ZONE_ACTIVATION_FAIL,
    UPDATE_SHIPPING_ZONE_ACTIVATION_SUCCESS,
    UPDATE_SHIPPING_ZONE_FAIL,
    UPDATE_SHIPPING_ZONE_SUCCESS
} from "./actionTypes"

const INIT_STATE = {
    shippingZoneListing: [],
    shippingZoneDetails: [],
    addShippingZone: [],
    updateShippingZone: [],
    updateShippingZoneActivation: [],
    deleteShippingZone: [],
    exportShippingZone: [],
    error: [],
}

const ShippingZone = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_SHIPPING_ZONE_LISTING_SUCCESS:
            return {
                ...state,
                shippingZoneListing: action.payload
            }
        case GET_SHIPPING_ZONE_LISTING_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case GET_SHIPPING_ZONE_DETAILS_SUCCESS:
            return {
                ...state,
                shippingZoneDetails: action.payload
            }
        case GET_SHIPPING_ZONE_DETAILS_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case ADD_SHIPPING_ZONE_SUCCESS:
            return {
                ...state,
                addShippingZone: action.payload
            }
        case ADD_SHIPPING_ZONE_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case UPDATE_SHIPPING_ZONE_SUCCESS:
            return {
                ...state,
                updateShippingZone: action.payload
            }
        case UPDATE_SHIPPING_ZONE_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case UPDATE_SHIPPING_ZONE_ACTIVATION_SUCCESS:
            return {
                ...state,
                updateShippingZoneActivation: action.payload
            }
        case UPDATE_SHIPPING_ZONE_ACTIVATION_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case DELETE_SHIPPING_ZONE_SUCCESS:
            return {
                ...state,
                deleteShippingZone: action.payload
            }
        case DELETE_SHIPPING_ZONE_FAIL:
            return {
                ...state,
                error: action.payload,
                deleteShippingZone: action.payload
            }

        case EXPORT_SHIPPING_ZONE_SUCCESS:
            return {
                ...state,
                exportShippingZone: action.payload
            }
        case EXPORT_SHIPPING_ZONE_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case RESET_SHIPPING_ZONE_STATE:
            return {
                ...state,
                shippingZoneListing: [],
                shippingZoneDetails: [],
                addShippingZone: [],
                updateShippingZone: [],
                updateShippingZoneActivation: [],
                deleteShippingZone: [],
                exportShippingZone: [],
                error: [],
            }
        case RESET_SHIPPING_ZONE_ACTION_STATE:
            return {
                ...state,
                exportShippingZone: [],
                addShippingZone: [],
                updateShippingZone: [],
                updateShippingZoneActivation: [],
                deleteShippingZone: [],
                exportShippingZone: [],
                error: [],
            }
        default:
            return state
    }
}

export default ShippingZone
